import React, { useState } from "react";
import Loader from "../../../shared/Loader.js";
import { Toast } from "../../../shared/Toast.js";
import API from "../../../services/api.js";
import { alphaformatDateTime } from "../../../utils/dateFormat.js";

const ModeOfPayment = ({ mode }) => {
  if (!mode) return "N/A";
  mode = (typeof mode ==="object" ? JSON.parse(mode) : {upi_id : mode});
  return (
    <>
      {mode.channel && <p><strong>Channel:</strong> {mode.channel}</p>}
      {mode.upi_id && <p><strong>UPI ID:</strong> {mode.upi_id}</p>}
    </>
  );
};

export default function GoLiveButton({ row, handleGoToLive, goLiveLoadingIdx, rowIdx }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const isLive = row.status === 7;
  const statusClass = isLive ? "bg-go_to_green text-white" : "bg-go_to_gray text-white";
  const { dateStr, timeStr } = alphaformatDateTime(paymentDetails.transaction_date_time || "");

  const fetchPaymentDetails = async () => {
    setLoading(true);
    const res = await API({ url: "/alpha_cst_designer/payment_details", method: "POST", data: { creative_id: row.creative_id } });
    if (res.status === "SUCCESS") setPaymentDetails(res.data);
    else Toast(res.message);
    setLoading(false);
  };

  const openModal = () => {
    if (isLive) {
      fetchPaymentDetails();
      setModalOpen(true);
    } else {
      Toast("error", "Cannot Go Live, Client Not Accepted or Payment Details not Found");
    }
  };

  const confirmGoLive = () => {
    setModalOpen(false);
    handleGoToLive(row, row.creative_id, rowIdx);
  };

  const cancelGoLive = () => {
    setPaymentDetails({});
    setModalOpen(false);
  };

  return (
    <>
      <button className={`px-2 py-1 rounded font-medium ${statusClass} flex items-center justify-center`} onClick={openModal} disabled={goLiveLoadingIdx === rowIdx}>
        {goLiveLoadingIdx === rowIdx ? <Loader /> : "Go To Live"}
      </button>

      {modalOpen && paymentDetails && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
            <h2 className="text-xl font-semibold mb-4">Confirm Go Live</h2>
            <div className="mb-4 space-y-2 text-gray-700">
              <p><strong>Reference ID:</strong> {paymentDetails.payment_ref_id || ""}</p>
              <p><strong>Received Amount:</strong> {paymentDetails.received_amount || 0}</p>
              <p><strong>Mode of Payment:</strong> <ModeOfPayment mode={paymentDetails.mode_of_payment} /></p>
              <p><strong>Transaction Date & Time:</strong> {dateStr + " " + timeStr}</p>
            </div>
            <div className="flex justify-end space-x-3">
              <button className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400" onClick={cancelGoLive}>Cancel</button>
              {!loading ? (
                <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700" onClick={confirmGoLive}>Confirm</button>
              ) : (
                <button disabled>Fetching Payment Details</button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
